import { Injectable, signal } from '@angular/core';
import { Observable, Subject } from 'rxjs';

interface ConfirmationPopupConfig {
  title: string;
  body: string;
  cancelButtonText: string;
  confirmButtonText: string;
}

@Injectable()
export class ConfirmationService {
  public confirmationPopupIsVisible = signal(false);
  public config = signal<ConfirmationPopupConfig>({
    title: '',
    body: '',
    cancelButtonText: '',
    confirmButtonText: ''
  });

  private resultSubject?: Subject<boolean>;

  constructor() {}

  public showConfirmationPopup(config: ConfirmationPopupConfig): Observable<boolean> {
    this.config.set(config);
    this.confirmationPopupIsVisible.set(true);

    this.resultSubject = new Subject<boolean>();
    return this.resultSubject.asObservable();
  }

  public confirm(result: boolean) {
    this.confirmationPopupIsVisible.set(false);
    this.resultSubject?.next(result);
    this.resultSubject?.complete();
    this.resultSubject = undefined;
  }
}
